import React, { useState, useEffect, useRef } from 'react';
import { Empty, DatePicker, message, Select, Button, Dropdown, Cascader, Pagination, Form, Popover, Table } from 'antd';
import { useHistory } from 'react-router-dom';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import moment from 'moment';//日期格式化导包
import { studentCheckLogin } from '../newMain/studentMain';
import StudentSeeAllJobPostingJobSort from './studentSeeAllJobPostingJobSort';

import './studentSeeAllJobPosting.css';

import searchImg from '../../public/img/newMain/Search.png';
import sortImg from '../../public/img/newMain/Sort.png';
import resetImg from '../../public/img/newMain/Reset.png';
import select1 from '../../public/img/std/select1.png';
import stdApplyingAction from '../../public/img/newMain/stdApplyingAction.png';
import exportImg from '../../public/img/newMain/Export.png'
import select3 from '../../public/img/std/select3.png'

const { Option } = Select;

const StudentSeeAllJobPosting = (props) => {
    const history = useHistory();
    const [jobList, setJobList] = useState([]);
    const [jobCount, setJobCount] = useState(0);
    const [pageSize, setPageSize] = useState(9);
    const [jobPostModel, setJobPostModel] = useState({});
    const [areaOptions, setAreaOptions] = useState([]);
    const [current, setCurrent] = useState(1);
    const [form] = Form.useForm();
    const [popoverVisible, setPopoverVisible] = useState(false);
    const [jobSortPostModel, setJobSortPostModel] = useState({});
    const [isReset, setIsReset] = useState(false);
    const [showMode, setShowMode] = useState('Box');
    const jobPostModelRef = useRef({});

    useEffect(() => {
        if (!Config.studentInfo?.studentId) {
            studentCheckLogin();
        }
        search(pageSize, 1);
        searchAllArea();
    }, []);

    const searchAllArea = () => {
        Base.callBackApi("commonDropDown/searchAllArea").then((data) => {
            if ("SUCCESS" === data.msg) {
                setAreaOptions(data?.object ?? []);
            } else {
                message.error(data.msg);
            }
        }).catch(err => { });
    }

    const itemRender = (_, type, originalElement) => {
        if (type === 'prev') {
            return <a>Previous</a>;
        }
        if (type === 'next') {
            return <a>Next</a>;
        }
        return originalElement;
    };

    const onChange = (currentNew, pageSizeNew) => {
        document.getElementById("container").scrollTop = 0;
        search(pageSizeNew, currentNew);
    }

    const onChangeAddressA = (value) => {
        setJobPostModel(model => {
            jobPostModelRef.current = { ...model, ...{ workLocId: value } };
            return { ...model, ...{ workLocId: value } };
        });
        search(pageSize, 1);
    }

    const search = (pageSizeNew, currentPageNew, flag, jobModel) => {
        let model = {}
        form.validateFields().then(() => {
            // if(!flag) {
            //     model = JSON.parse(JSON.stringify(jobPostModel));
            // }
            if (jobSortPostModel) {
                model = { ...jobSortPostModel }
            }
            if (jobModel) {
                model = { ...jobModel }
            }
            if (!flag) {
                let formModel = JSON.parse(JSON.stringify(jobPostModelRef.current));
                model.appDeadStartDate = formModel.appDeadStartDate
                model.appDeadEndDate = formModel.appDeadEndDate
                model.jobTitle = formModel.jobTitle
                if (Base.isNotEmpty(formModel.workLocId)) {
                    if (formModel.workLocId[1]) {
                        model.workLocId = formModel.workLocId[1];
                    } else {
                        model.workLocId = formModel.workLocId[0];
                    }
                }
            }
            model.pageSize = pageSizeNew;
            model.startRow = (currentPageNew - 1) * pageSizeNew;
            model.page = currentPageNew;
            model.progCode = Config.studentInfo?.progCode
            Base.callBackApi("studentJob/search", model).then((data) => {
                if ("SUCCESS" === data?.msg) {
                    setJobList(data?.object?.list ?? [])
                    setJobCount(data?.object?.total ?? 0)
                    setCurrent(currentPageNew);
                    setPageSize(pageSizeNew);
                } else {
                    message.error(data?.msg)
                }
            })
        })
    }

    const reset = () => {
        jobPostModelRef.current = {};
        setJobPostModel({});
        setJobSortPostModel({})
        form.resetFields()
        setIsReset(true)
        search(9, 1, true, {});
    }

    const modelChange = (key, value) => {
        setJobPostModel(model => {
            jobPostModelRef.current = { ...model, ...{ [key]: value } };
            return { ...model, ...{ [key]: value } };
        });
        if (Base.afterDate(form.getFieldValue('appDeadStartDate'), form.getFieldValue('appDeadEndDate')) ||
            Base.afterDate(form.getFieldValue('appDeadStartDate'), form.getFieldValue('appDeadEndDate'))) {
            return
        }
        search(pageSize, 1);
    }

    const jump = (path) => {
        history.push(path);
    }

    const handleOpenChange = (newOpen) => {
        setPopoverVisible(newOpen);
    };

    const handleOpenChange2 = (newOpen, status, jobSortJobPostModel) => {
        if (status) {
            setJobSortPostModel(jobSortJobPostModel)
            search(pageSize, 1, false, jobSortJobPostModel)
        }
        setIsReset(false)
        setPopoverVisible(newOpen);
    };

    const checkStartDate2 = (rule, value) => {
        if (Base.isNotEmpty(form.getFieldValue('appDeadEndDate')) && Base.afterDate(form.getFieldValue('appDeadStartDate'), form.getFieldValue('appDeadEndDate'))) {
            return Promise.reject("The start date cannot be later than the end date.");
        }
        return Promise.resolve();
    }

    const checkEndDate2 = (rule, value) => {
        if (Base.isNotEmpty(form.getFieldValue('appDeadStartDate')) && Base.afterDate(form.getFieldValue('appDeadStartDate'), form.getFieldValue('appDeadEndDate'))) {
            return Promise.reject("The end date cannot be earlier than the start date.")
        }
        return Promise.resolve();
    }

    const changeShowMode = (value) => {
        setShowMode(value)
    }

    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1);
    }

    const tableColumns = {
        jobId: "job_id",
        companyName: "company_name",
        jobTitle: "job_title",
        progTitle: "prog_title",
        positionType: "position_type",
        workLocVal: "work_loc_val",
        expCommenceDate: "exp_commence_date",
        expEndDate: "exp_end_date", 
        salaryRangeFrom: "salary_range_from",
        lastApplyDate: "last_apply_date",
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!jobSortPostModel.orderBy) {
            if (orderBy !== jobSortPostModel.orderBy) {
                jobSortPostModel.orderBy = orderBy;
                search(pageSize, 1);
            }
        }
    }

    /*eslint-disable*/
    const columns = [
        {
            title: 'Job ID',
            dataIndex: 'jobId',
            className: 'tableWidth6',
            render: text => text ? '#' + text : '',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobId') },
        },
        {
            title: 'Industry Partner',
            dataIndex: 'companyName',
            className: 'tableWidth11',
            render: (text, record) => (
                <Popover content={text} title="" trigger="hover">
                    <div className='tableFlexBox'>
                        <div className='tableImgBox'>
                            {record.companyLogo && <img src={Config.partnerImg + record.companyLogo + '?' + Config.sasToken} />}
                        </div>
                        <div className='tableProgramme'>
                            {text}
                        </div>
                    </div>
                </Popover>
            ),
            sorter: (a, b) => { return Base.sortMethod(a, b, 'companyName') },
        },
        {
            title: 'Job Title',
            dataIndex: 'jobTitle',
            className: 'tableWidth10',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobTitle') },
        },
        {
            title: 'THEi Programme',
            dataIndex: 'progTitle',
            className: 'tableWidth11',
            render: text => (
                <Popover content={text} title="" trigger="hover">
                    <div className='tableProgrammeBox'>{text}</div>
                </Popover>
            ),
            sorter: (a, b) => { return Base.sortMethod(a, b, 'progTitle') },
        },
        {
            title: 'Job Mode',
            dataIndex: 'positionTypeVal',
            className: 'tableWidth9',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'positionTypeVal') },
        },
        {
            title: 'Work Location',
            dataIndex: 'workLocVal',
            className: 'tableWidth10',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'workLocVal') },
        },
        {
            title: 'Commence Date',
            dataIndex: 'expCommenceDate',
            className: 'tableWidth11',
            render: text => text ? moment(text).format(Config.dateFormatEn) : '',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'expCommenceDate') },
        },
        {
            title: 'End Date',
            dataIndex: 'expEndDate',
            className: 'tableWidth8',
            render: text => text ? moment(text).format(Config.dateFormatEn) : '',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'expEndDate') },
        },
        {
            title: 'Salary/Salary Basis',
            dataIndex: 'salaryRangeFrom',
            className: 'tableWidth13',
            render: (text, record) => text + '~' + record.salaryRangeTo + ' ' + (record.unitVal ?? ''),
            sorter: (a, b) => { return Base.sortMethod(a, b, 'salaryRangeFrom') },
        },
        {
            title: 'Application Deadline',
            dataIndex: 'lastApplyDate',
            className: 'tableWidth11',
            render: text => text ? moment(text).format(Config.dateFormatEn) : '',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'lastApplyDate') },
        },
        {
            title: 'Action',
            dataIndex: 'jobId',
            fixed: 'right',
            width: 80,
            render: (text, record) => (
                <Dropdown trigger={['hover']}
                    destroyPopupOnHide={true}
                    placement="bottom"
                    dropdownRender={() =>
                        <div >
                            <Button icon={<img src={select1} />} onClick={() => jump('/student/studentJobDetail/' + text + '/view')}>Review</Button>
                            {record.lastApplyDate >= moment().startOf('day').valueOf() && <Button icon={<img src={select3} />} onClick={() => jump('/student/studentJobDetail/' + text + '/apply')}>Apply</Button>}
                        </div>
                    }
                >
                    <div className='tableAction'><img src={exportImg} /></div>
                </Dropdown>
            )
        },
    ];
    /*eslint-disable*/

    return (
        <div id="container" className='websiteTemplate studentSeeAllJobPosting'>
            <div className='paddingBox'>
                <div className='homeTitle'>All Job Postings</div>
                <Form form={form}>
                    <div className="websiteSysSearchRow" style={{ marginTop: '10px' }}>
                        <div className='searchFlex'>
                            <div className='label'>Application Deadline: </div>
                            <div className='searchFlex'>
                                <div style={{ position: "relative" }} id="appDeadStartDate">
                                    <Form.Item
                                        name="appDeadStartDate"
                                        rules={[// 声明式验证: 直接使用别人定义好的验证规则进行验证
                                            { validator: (rule, value) => checkStartDate2(value) },
                                        ]}>
                                        <DatePicker placeholder=""
                                            className="searchDatePickerWidth"
                                            value={jobPostModel?.appDeadStartDate ? moment(new Date(jobPostModel.appDeadStartDate), Config.dateFormatEn) : null}
                                            onChange={(value) => modelChange("appDeadStartDate", value)}
                                            format={Config.dateFormatEn}
                                            getPopupContainer={() => document.getElementById('appDeadStartDate')}
                                        />
                                    </Form.Item>
                                </div>
                                <span>-</span>
                                <div style={{ position: "relative" }} id="appDeadEndDate">
                                    <Form.Item
                                        name="appDeadEndDate"
                                        rules={[// 声明式验证: 直接使用别人定义好的验证规则进行验证
                                            { validator: (rule, value) => checkEndDate2(value) },
                                        ]}>
                                        <DatePicker placeholder=""
                                            className="searchDatePickerWidth"
                                            value={jobPostModel?.appDeadEndDate ? moment(new Date(jobPostModel.appDeadEndDate), Config.dateFormatEn) : null}
                                            onChange={(value) => modelChange("appDeadEndDate", value)}
                                            format={Config.dateFormatEn}
                                            getPopupContainer={() => document.getElementById('appDeadEndDate')}
                                        />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className='searchFlex'>
                            <div className='label'>Work Location: </div>
                            <div>
                                <Cascader value={jobPostModel?.workLocId || []}
                                    options={areaOptions}
                                    onChange={onChangeAddressA}
                                    placeholder="Work Location"
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                    changeOnSelect
                                />
                            </div>
                        </div>
                        <div className='searchFlex'>
                            <div className='label searchViewPotionTitle'>View Option:</div>
                            <Select
                                className='searchViewPotion'
                                value={showMode}
                                options={[
                                    {
                                        label: 'Box',
                                        value: 'Box'
                                    },
                                    {
                                        label: 'List',
                                        value: 'List'
                                    },
                                ]}
                                onChange={(value) => changeShowMode(value)}
                            />
                        </div>
                    </div>
                </Form>
                <div className='websiteSysSearchRow'>
                    <div className='websiteSysSearchBar'>
                        <input placeholder="Search By job title or by job ID"
                            value={jobPostModel?.jobTitle || ''}
                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1) : null}
                            onChange={(e) => modelChange("jobTitle", e.target.value)} />
                        <img src={searchImg} onClick={() => search(pageSize, 1)} />
                    </div>
                    <Popover placement="topRight" trigger="click" open={popoverVisible}
                        onOpenChange={handleOpenChange} content={
                            <StudentSeeAllJobPostingJobSort isReset={isReset} onOpenChange={handleOpenChange2} />
                        }
                        getPopupContainer={() => document.getElementById('sortButton')}
                    >
                        <div className='websiteSysButton sortButton' id='sortButton'><img src={sortImg} />Sort</div>
                    </Popover>
                    <div className='websiteSysButton sortButton' onClick={reset}><img src={resetImg} />Reset</div>
                </div>
            </div>
            {showMode === 'Box' ?
                <>
                    {Base.isEmpty(jobList) ? <Empty /> : ''}
                    <div className='seeAllCardBox'>
                        {
                            jobList.map(item =>
                                <div className='allCardBoxDiv borderColorAssigned' key={item.jobId}>
                                    <div className='cardProgrammeRow'>
                                        <div className='cardProgrammeBox' title={item.progTitle}>
                                            <div className='cardProgrammeText'>{item.progTitle}</div>
                                        </div>
                                        <div className='cardCompanyBox' title={item.companyName}>
                                            {item.companyLogo && <img src={Config.partnerImg + item.companyLogo + '?' + Config.sasToken} />}
                                            <div className='cardProgrammeText'>{item.companyName}</div>
                                        </div>
                                    </div>
                                    <div className='cardTitleBox'>
                                        <div className='cardTitle' title={item.jobTitle}>{item.jobTitle}</div>
                                    </div>
                                    <div className='flexBox'>
                                        <div className='label'>Job ID</div>
                                        <div className='value'>
                                            {item.jobId}
                                        </div>
                                    </div>
                                    <div className='flexBox'>
                                        <div className='label'>Job Mode</div>
                                        <div className='value'>
                                            {item.positionTypeVal}
                                        </div>
                                    </div>
                                    <div className='flexBox'>
                                        <div className='label'>Work Location</div>
                                        <div className='value'>{item.workLocVal}</div>
                                    </div>
                                    <div className='flexBox'>
                                        <div className='label'>Commence-End</div>
                                        <div className='value'>
                                            {item.expCommenceDate ? moment(item.expCommenceDate).format(Config.dateFormatEn) : ''} ~ {item.expEndDate ? moment(item.expEndDate).format(Config.dateFormatEn) : ''}
                                        </div>
                                    </div>
                                    <div className='flexBox'>
                                        <div className='label'>Salary/Salary Basis</div>
                                        <div className='value'>
                                            HK$ {item.salaryRangeFrom} ~ {item.salaryRangeTo} {item.unitVal}
                                        </div>
                                    </div>
                                    <div className='flexBox'>
                                        <div className='label'>Application Deadline</div>
                                        <div className='value'>
                                            {item.lastApplyDate ? moment(item.lastApplyDate).format(Config.dateFormatEn) : ''}
                                        </div>
                                    </div>
                                    <div className='cardLine'></div>
                                    <div className='cardButtonBox' >
                                        <Dropdown trigger={['hover']}
                                            destroyPopupOnHide={true}
                                            placement="bottomLeft"
                                            dropdownRender={() =>
                                                <div >
                                                    <Button icon={<img src={select1} />} onClick={() => jump('/student/studentJobDetail/' + item.jobId + '/view')}>Review</Button>
                                                    {item.lastApplyDate >= moment().startOf('day').valueOf() && <Button icon={<img src={select3} />} onClick={() => jump('/student/studentJobDetail/' + item.jobId + '/apply')}>Apply</Button>}
                                                </div>
                                            }

                                        >
                                            <Button icon={<img src={stdApplyingAction} />} className='cardButton '>Action</Button>
                                        </Dropdown>
                                        {/* <Button icon={<img src={inspectImg} />} className='cardButton ' onClick={() => jump('/student/studentJobDetail/' + item.jobId + '/apply')}>Review</Button> */}
                                    </div>
                                </div>
                            )}
                    </div>
                    {jobCount > 9 && <div className="pagination">
                        <Pagination defaultCurrent={1}
                            current={current}
                            pageSize={9}
                            total={jobCount}
                            itemRender={itemRender}
                            showSizeChanger={false}
                            onChange={onChange}
                        />
                    </div>}
                </>
                :
                <div className="sysTable" id="tableOne" style={{ margin: '0 20px' }}>
                    <Table
                        scroll={{ x: 1200 }}
                        rowKey="jobApplId"
                        columns={columns} //列名
                        dataSource={jobList} //数据
                        pagination={{  //分页
                            showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                            onChange: onChange,            //上页下页或者跳页方法
                            onShowSizeChange: onShowSizeChange,    //每页显示多少条数据方法
                            total: jobCount,             //总共多少条数据
                            current: current,         //当前页
                            pageSize: pageSize,       //每页显示多少条数据
                            defaultCurrent: 1,                               //默认当前页为1
                            size: "small"
                        }}
                        onChange={handleTableChange}
                    />
                </div>
            }
        </div>
    )

}

export default StudentSeeAllJobPosting;